import {useMemo, useState} from 'react'

import useDebounce from './use-debounce'
import useMemoDeferred from './use-memo-deferred'

const useSearch = <Searchable>(
  searchableList: Searchable[],
  createSearch: (searchable: Searchable[]) => {search: (term: string) => Searchable[]},
  disabled = false,
  initialSearchValue = ''
) => {
  const [searchValue, setSearchValue] = useState(initialSearchValue)

  const {search} = useMemoDeferred<{search: (term: string) => Searchable[]}>(
    () => createSearch(disabled ? [] : searchableList),
    [searchableList, disabled],
    () => ({search: () => searchableList})
  )

  const debouncedSearchValue = useDebounce(searchValue, 300)

  const searchResults = useMemo(
    () => (debouncedSearchValue.length > 0 ? search(debouncedSearchValue) : searchableList),
    [debouncedSearchValue, searchableList, search]
  )

  return {
    searchValue,
    debouncedSearchValue,
    setSearchValue,
    searchResults,
  }
}

export default useSearch
